// extracted by mini-css-extract-plugin
module.exports = {"padding_compensate":"CategoryNav_padding_compensate___kNG0"};